const BRAINTREE_URLS = {
  apple_pay_sessions: 'apple_pay_web/sessions',
  tokens: 'payment_methods/apple_payment_tokens'
}

export default (api) => ({
  apple_pay_init: (data) => api.post(BRAINTREE_URLS.apple_pay_sessions, data),
  tokens: (data) => api.post(BRAINTREE_URLS.tokens, data)
})
